import { NavLink, useLocation } from 'react-router-dom';
import type { ComponentType, SVGProps } from 'react';
import { isSidebarPathActive } from './isSidebarPathActive';

type IconComponent = ComponentType<SVGProps<SVGSVGElement>>;

type SidebarNavItemProps = {
  to: string;
  label: string;
  icon: IconComponent;
  collapsed?: boolean;
  onNavigate?: () => void;
  /** Outras rotas do mesmo grupo; evita marcar o pai quando um filho mais específico está ativo. */
  siblingPaths?: readonly string[];
};

export function SidebarNavItem({
  to,
  label,
  icon: Icon,
  collapsed = false,
  onNavigate,
  siblingPaths = [],
}: SidebarNavItemProps) {
  const location = useLocation();
  const isActive = isSidebarPathActive(location.pathname, to, siblingPaths);

  return (
    <NavLink
      to={to}
      title={collapsed ? label : undefined}
      aria-label={label}
      aria-current={isActive ? 'page' : undefined}
      onClick={onNavigate}
      className={() =>
        [
          'flex items-center rounded-xl text-sm font-medium transition-colors',
          collapsed ? 'justify-center px-2 py-2.5' : 'gap-3 px-3 py-2',
          isActive
            ? 'bg-white/15 text-white'
            : 'text-primary-100 hover:bg-white/10 hover:text-white',
        ].join(' ')
      }
    >
      <Icon className="h-5 w-5 shrink-0" aria-hidden="true" />
      {!collapsed ? <span className="truncate">{label}</span> : null}
    </NavLink>
  );
}
